import type { components } from "@/api-schema";

type Vehicle = components["schemas"]["Vehicle"];

export function getVehicleBuyInTitle(vehicle?: Vehicle, fallbackBrandName?: string): string {
  const brandName = vehicle?.modelGeneration?.modelFamily?.brand?.name?.trim() || fallbackBrandName?.trim() || "";
  const modelName =
    vehicle?.modelDescription?.trim() ||
    vehicle?.modelGeneration?.name?.trim() ||
    vehicle?.modelGeneration?.modelFamily?.name?.trim() ||
    "";

  return [brandName, modelName].filter(Boolean).join(" ");
}
